import { TableData } from '@models/table-data';

// table data for landing page
export const damagesTable: TableData = {
    subtitles: [
        'Schäden',
        'Hersteller&shy;garantie & Gewähr&shy;leistung',
        'astra Versicherung für Elektronikgeräte<br />ohne Selbstbeteiligung',
        'astra Versicherung für Elektronikgeräte<br />mit Selbstbeteiligung',
    ],
    collapsedTitle: 'Schäden',
    rows: [
        {
            title: 'Bedienungsfehler',
            cells: [
                { type: 'check', checkmark: false, value: '' },
                { type: 'check', checkmark: true, value: '' },
                { type: 'check', checkmark: true, value: 'SB: €&nbsp;35' },
            ],
        },
        {
            title: 'Bodenstürze, Bruch-, Flüssigkeits- und Displayschäden',
            cells: [
                { type: 'check', checkmark: false, value: '' },
                { type: 'check', checkmark: true, value: '' },
                { type: 'check', checkmark: true, value: 'SB: €&nbsp;35' },
            ],
        },
        {
            title: 'Brand, Blitzschlag, Explosion, Implosion, Überspannung, Induktion, Kurzschluss',
            cells: [
                { type: 'check', checkmark: false, value: '' },
                { type: 'check', checkmark: true, value: '' },
                { type: 'check', checkmark: true, value: 'SB: €&nbsp;35' },
            ],
        },
        {
            title: 'Diebstahl, Einbruchdiebstahl, Raub',
            cells: [
                { type: 'check', checkmark: false, value: '' },
                { type: 'check', checkmark: true, value: '' },
                { type: 'check', checkmark: true, value: 'SB: 15% vom Kaufpreis' },
            ],
        },
        {
            title: 'Sabotage, Vandalismus, Beschädigung durch Dritte',
            cells: [
                { type: 'check', checkmark: false, value: '' },
                { type: 'check', checkmark: true, value: '' },
                { type: 'check', checkmark: true, value: 'SB: €&nbsp;35' },
            ],
        },
        {
            title: 'Laufzeit',
            cells: [
                { type: 'text', value: 'Bis zu 24 Monate' },
                { type: 'text', value: 'unbegrenzt' },
                { type: 'text', value: 'unbegrenzt' },
            ],
        },
        {
            title: 'Keine Selbstbeteiligung',
            cells: [
                { type: 'check', checkmark: true },
                { type: 'check', checkmark: true },
                { type: 'check', checkmark: false },
            ],
        },
        {
            title: 'Konstruktions-, Material- und Montagefehler',
            cells: [
                { type: 'check', checkmark: true, value: '' },
                { type: 'check', checkmark: false, value: '' },
                { type: 'check', checkmark: false, value: '' },
            ],
        },
    ],
    highlighted: 2,
};
